import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import useUser from "../hooks/useUser";

export default function ResourceDetail() {
  const { slug } = useParams();
  const { user } = useUser();
  const navigate = useNavigate();

  const title = slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-4 py-16">
        <div className="bg-white rounded-2xl shadow-soft border p-8 text-center">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-ink mb-3">
            Sign in to view {title} resources
          </h1>
          <p className="text-ink/70 mb-6">
            This page is only available to registered users. Please log in to
            access the materials for <strong>{title}</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate("/login")}
              className="rounded-xl bg-brand-500 text-white font-semibold px-6 py-2.5 hover:bg-brand-600"
            >
              Log in
            </button>
            <button
              onClick={() => navigate("/register")}
              className="rounded-xl border border-brand-300 text-ink px-6 py-2.5 hover:bg-ash"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-extrabold text-ink mb-6">
        {title} Resources
      </h1>

      <div className="rounded-2xl bg-white border shadow-soft p-6 min-h-[200px]">
        {/* content */}
      </div>
    </div>
  );
}
